import { createSlice } from '@reduxjs/toolkit'
import { getChallengeInsights, getChallengeLeaderboard } from './thunks'
import { RootState } from 'store'

interface LeaderboardsState {
  leaderboards: { [challengeId: string]: ChallengeLeaderboardEntry[] }
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
  leaderboardStatus: 'idle' | 'loading' | 'succeeded' | 'failed'
  leaderboardError: string | null
}

const initialState: LeaderboardsState = {
  leaderboards: {},
  status: 'idle',
  error: null,
  leaderboardStatus: 'idle',
  leaderboardError: null,
}

const slice = createSlice({
  name: 'leaderboards',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getChallengeLeaderboard.pending, (state) => {
        state.leaderboardStatus = 'loading'
        state.leaderboardError = null
      })
      .addCase(getChallengeLeaderboard.rejected, (state, action) => {
        state.leaderboardStatus = 'failed'
        state.leaderboardError = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(getChallengeLeaderboard.fulfilled, (state) => {
        state.leaderboardStatus = 'succeeded'
        // TODO: Handle getting challenge leaderboard entries, participants route?
        // const leaderboards = action.payload.data.filter((lb) => lb.type === 'all')
        // if (leaderboards.length > 0) {
        //   state.leaderboards[action.meta.arg.challengeId] = leaderboards[0].entries
        // }
      })
    builder
      .addCase(getChallengeInsights.pending, (state) => {
        state.leaderboardStatus = 'loading'
        state.leaderboardError = null
      })
      .addCase(getChallengeInsights.rejected, (state, action) => {
        state.leaderboardStatus = 'failed'
        state.leaderboardError = action?.payload?.message || 'Something went wrong. Please try again.'
      })
      .addCase(getChallengeInsights.fulfilled, (state) => {
        state.leaderboardStatus = 'succeeded'
      })
  },
})

export const selectLeaderboards = (state: RootState) => state.leaderboards

export const selectLeaderboard = (state: RootState, challengeId: string) =>
  state.leaderboards.leaderboards[challengeId] || []

export default slice.reducer
